import Mock from 'mockjs'

// 仅供开发阶段调试，用完删除
// Mock.mock('/api/play/testmock', {
//     s: 200,
//     data: {
//         'name': '@name',

//         'age|1-100': 50,

//         'img': '@img(100x100)',

//         'sex|0-1': 0,
//         // 模拟名称
//         'userName': '@name',
//         // 模拟色值
//         'color': '@color',
//         // 模拟时间
//         'date': '@date("yyyy-MM-dd")',
//         // 模拟url
//         'url': '@url()',
//         // 模拟文本
//         'content': '@cparagraph()',

//         'now': '@now'
//     },
//     msg: null
// })


export default Mock
